import { Box, IconButton, Tooltip, Chip } from "@mui/joy";
import { Info as InfoIcon } from "lucide-react";
import { useNavigate } from "react-router-dom";
import type { ICellRendererParams } from "ag-grid-community";

/**
 * Info cell renderer - navigates to edit product category page
 */
export function Info(props: any) {
    const navigate = useNavigate();
    const { value } = props;

    const handleClick = () => {
        navigate(`/admin/product-category/${value}`);
    };

    return (
        <Box display={"flex"} justifyContent={"center"} alignItems={"center"} height={"100%"}>
            <Tooltip title="View details" placement="top">
                <IconButton
                    size="sm"
                    variant="soft"
                    color="primary"
                    onClick={handleClick}
                    sx={{ "--IconButton-size": "32px" }}
                >
                    <InfoIcon size={16} />
                </IconButton>
            </Tooltip>
        </Box>
    );
}

/**
 * Status cell renderer
 */
export function StatusCellRenderer(params: ICellRendererParams) {
    const isActive = params.value === 1 || params.value === true;

    return (
        <Chip
            variant="soft"
            color={isActive ? "success" : "neutral"}
            size="md"
            sx={{
                fontWeight: 500,
                border: "1px solid",
                borderColor: "divider",
            }}
        >
            {isActive ? "Active" : "Inactive"}
        </Chip>
    );
}
